export default __webpack_public_path__ + "static/media/Install.85f97b63.svg";